import React from "react";
import { Box, Typography, Grid, Paper, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GroupsIcon from "@mui/icons-material/Groups";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { alpha } from "@mui/material/styles";
import DashboardLayout from "../../../layouts/DashboardLayout";

export default function TrsRastreoMainPage() {
  const navigate = useNavigate();

  const modulos = [
    {
      title: "Usuarios",
      description: "Credenciales y permisos de TRS Rastreo",
      icon: <PeopleIcon fontSize="small" />,
      path: "/trsrastreo/usuarios",
      color: "#1976d2",
      bg: "#e8f2ff",
    },
    {
      title: "Vehiculos",
      description: "Administracion y seguimiento de vehiculos",
      icon: <DirectionsCarIcon fontSize="small" />,
      path: "/trsrastreo/vehiculos",
      color: "#18864b",
      bg: "#e9f7ef",
    },
    {
      title: "Grupos",
      description: "Administracion y asignacion de grupos",
      icon: <GroupsIcon fontSize="small" />,
      path: "/trsrastreo/grupos",
      color: "#f25b1d",
      bg: "#fff0e9",
    },
  ];

  return (
    <DashboardLayout>
      <Box
        sx={{
          minHeight: "calc(100vh - 56px)",
          py: { xs: 2, md: 3.5 },
          backgroundColor: "background.default",
          backgroundImage: (theme) => `
            radial-gradient(circle at 1px 1px, ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.18 : 0.16)} 1px, transparent 0),
            linear-gradient(135deg, transparent 0%, transparent 62%, ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.1 : 0.07)} 62%, ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.1 : 0.07)} 100%)
          `,
          backgroundSize: "24px 24px, 100% 100%",
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ mb: { xs: 2, md: 3.5 }, pt: { md: 0.5 } }}>
            <Typography
              variant="h4"
              fontWeight="900"
              color="text.primary"
              sx={{ lineHeight: 1.05, fontSize: { xs: "1.75rem", md: "2.35rem" } }}
            >
              TRS Rastreo
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mt: 1, fontSize: { xs: "0.95rem", md: "1.05rem" }, fontWeight: 500 }}
            >
              Seleccione el modulo que desea administrar
            </Typography>
          </Box>

          <Grid container spacing={{ xs: 1.5, md: 2 }}>
            {modulos.map((item) => (
              <Grid item xs={12} sm={4} key={item.title}>
                <Paper
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate(item.path)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") navigate(item.path);
                  }}
                  elevation={0}
                  sx={{
                    position: "relative",
                    minHeight: { xs: 150, md: 190 },
                    p: { xs: 2, md: 2.4 },
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    color: "text.primary",
                    bgcolor: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.background.paper, 0.9)
                        : alpha(theme.palette.background.paper, 0.92),
                    cursor: "pointer",
                    overflow: "hidden",
                    boxShadow: (theme) =>
                      theme.palette.mode === "dark"
                        ? `0 18px 45px ${alpha(theme.palette.common.black, 0.28)}`
                        : "0 18px 45px rgba(15, 23, 42, 0.08)",
                    transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      borderColor: item.color,
                      boxShadow: (theme) =>
                        theme.palette.mode === "dark"
                          ? `0 24px 60px ${alpha(item.color, 0.18)}`
                          : "0 24px 60px rgba(15, 23, 42, 0.13)",
                    },
                    "&:focus-visible": {
                      outline: `2px solid ${item.color}`,
                      outlineOffset: 3,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      bgcolor: (theme) =>
                        theme.palette.mode === "dark"
                          ? alpha(item.color, 0.16)
                          : item.bg,
                      color: item.color,
                      display: "grid",
                      placeItems: "center",
                      mb: 1.6,
                      "& svg": { fontSize: 28 },
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box sx={{ pr: 3 }}>
                    <Typography variant="h6" fontWeight="900" sx={{ lineHeight: 1.1, mb: 1 }}>
                      {item.title}
                    </Typography>
                    <Typography color="text.secondary" sx={{ fontSize: "0.9rem", lineHeight: 1.35 }}>
                      {item.description}
                    </Typography>
                  </Box>
                  <ArrowForwardIcon
                    sx={{
                      position: "absolute",
                      right: 20,
                      bottom: 20,
                      color: item.color,
                      fontSize: 24,
                    }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </DashboardLayout>
  );
}
